import {
    isoAndUnixZodSchema,
    type IsoAndUnixTimestamp,
} from "@@/shared/date-time/iso-and-unix";
import type { LiteralUnion } from "type-fest";
import { z } from "zod";
import type { OrderEvent } from "../../order-events/events/_order-event";
import {
    orderEventIdZodSchema,
    type OrderEventId,
} from "../../order-events/events/_order-event-id";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type OrderEventTypeExtract = Extract<OrderEvent, { type: any }>["type"];
type OrderEventType = LiteralUnion<OrderEventTypeExtract, string>;

type OrderEventMini = {
    readonly _id: OrderEventId;
    readonly _type: "ORDER_EVENT_MINI";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly _version: number;
    readonly type: OrderEventType;
};

const orderEventMiniFactory = (event: OrderEvent): OrderEventMini => {
    return {
        _id: event._id,
        _type: "ORDER_EVENT_MINI",
        _createdAt: event._createdAt,
        _version: event._version,
        type: event.type,
    } as OrderEventMini;
};

const miniOrderEventZodSchema: z.ZodSchema<OrderEventMini> = z.object({
    _id: orderEventIdZodSchema,
    _type: z.literal("ORDER_EVENT_MINI"),
    _createdAt: isoAndUnixZodSchema,
    _version: z.number().int().min(0),
    type: z.string(),
});

export {
    orderEventMiniFactory as miniOrderEventFactory,
    miniOrderEventZodSchema,
};
export type { OrderEventMini };
